(function () {
    'use strict';

    angular
        .module('app')
        .service('searchService', searchService);

    searchService.$inject = ['$http'];

    function searchService($http) {
        /* jshint validthis:true */
        var vm = this;
        var baseUrl = '/api/search';
        vm.freetextsearch = freetextsearch;


        function freetextsearch(query, take, skip) {
            return $http({
                url: baseUrl + '/freetext',
                method: "POST",
                params: { query: query, take: take, skip: skip }
            });
        }
    }
})();